import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { OptionGroupFormItem } from "./OptionGroupForm"
import type {
    CategoryOptionGroup,
    CategoryOptionGroupOverride,
    OptionGroupLocationSaveRequestData,
    OptionGroupSaveRequestData,
} from "../../../../graphql/types"

export const OPTION_GROUP_FORM_SUBMITTED = "optionGroup/form/submitted"

export const optionGroupFormSubmitted = (oldValue: Maybe<OptionGroupFormItem>, newValue: OptionGroupFormItem) => ({
    type: OPTION_GROUP_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const CREATE_OPTION_GROUP_SUBMITTED = "group/create/submitted"

export const createOptionGroupSubmitted = (optionGroupFormItem: OptionGroupFormItem) => ({
    type: CREATE_OPTION_GROUP_SUBMITTED,
    payload: {
        newValue: optionGroupFormItem,
    },
})

export const EDIT_OPTION_GROUP_FORM_SUBMITTED = "optionGroup/edit/submitted"

export const editOptionGroupFormSubmitted = (oldValue: OptionGroupFormItem, newValue: OptionGroupFormItem) => ({
    type: EDIT_OPTION_GROUP_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_OPTION_GROUP_CLICKED = "option-group/delete/clicked"

export const deleteOptionGroupClicked = (id: string) => ({
    type: DELETE_OPTION_GROUP_CLICKED,
    payload: {
        optionGroupId: id,
    },
})

export const CLOSE_OPTION_GROUP_FORM_CLICKED = "option-group/close/clicked"

export const closeOptionGroupFormClicked = () => ({
    type: CLOSE_OPTION_GROUP_FORM_CLICKED,
})
// Api actions

export const OPTION_GROUP_SAVE_REQUESTED = "optionGroup/save/requested"

export const optionGroupSaveRequested = (data: OptionGroupSaveRequestData) => ({
    type: OPTION_GROUP_SAVE_REQUESTED,
    payload: {
        data: data,
    },
})

export const OPTION_GROUP_SAVE_SUCCESS = "optionGroup/save/success"
export const optionGroupSaveSuccess = (data: CategoryOptionGroup) => ({
    type: OPTION_GROUP_SAVE_SUCCESS,
    payload: {
        data: data,
    },
})

export const OPTION_GROUP_SAVE_FAILURE = "optionGroup/save/failure"

export const optionGroupSaveFailure = (error: any) => ({
    type: OPTION_GROUP_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const OPTION_GROUP_LOCATION_SAVE_REQUESTED = "optionGroup/location/save/requested"

export const optionGroupLocationSaveRequested = (data: OptionGroupLocationSaveRequestData, locationId: string) => ({
    type: OPTION_GROUP_LOCATION_SAVE_REQUESTED,
    payload: {
        data: data,
        locationId: locationId,
    },
})

export const OPTION_GROUP_LOCATION_SAVE_SUCCESS = "optionGroup/location/save/success"

export const optionGroupLocationSaveSuccess = (
    data: Maybe<CategoryOptionGroupOverride>,
    saveRequestData: Maybe<OptionGroupLocationSaveRequestData>,
    locationId: string
) => ({
    type: OPTION_GROUP_LOCATION_SAVE_SUCCESS,
    payload: {
        data: data,
        saveRequestData: saveRequestData,
        locationId: locationId,
    },
})

export const OPTION_GROUP_LOCATION_SAVE_FAILURE = "optionGroup/location/save/failure"

export const optionGroupLocationSaveFailure = (error: any) => ({
    type: OPTION_GROUP_LOCATION_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const OPTION_GROUPS_DELETED = "option-groups/deleted"
export const optionGroupsDeleted = (ids: string[]) => ({
    type: OPTION_GROUPS_DELETED,
    payload: {
        ids: ids,
    },
})
